import { useEffect } from "react";
import { useToast } from "@/hooks/use-toast";

export function PdfTemplateWarningListener() {
  const { toast } = useToast();
  useEffect(() => {
    const warn = (event: Event) => toast({
      title: "PDF exported without design images",
      description: (event as CustomEvent<string>).detail,
    });
    window.addEventListener("pdf-template-warning", warn);
    return () => window.removeEventListener("pdf-template-warning", warn);
  }, [toast]);
  return null;
}
